<template>
    <div id="main">
        <div class="platform-header">
            <div class="platform-logo-container">
                <div class="title platform-logo-container__title">教育管理平台</div>
                <!-- <div class="title platform-logo-container__title"><i class="logo"></i>区域教育管理平台</div> -->
            </div>
            <div class="navbar-munu">
                <ul class="nav-item-container">
                    <li
                        v-if="!navItem.permissionPath || isShowByPermission(navItem.permissionPath)"
                        v-for="navItem in navbarList"
                        class="nav-item"
                    >
                        <router-link
                            class="nav-item__link"
                            :to="navItem.path"
                        >{{navItem.name}}
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="platform-user">

                <el-dropdown trigger="click">
                    <div class="platform-user__avatar-container">
                        <div class="platform-user__avatar-inner clearfix"><img
                            :src="userInfo.avatar"
                            class="platform-user__avatar"
                        >
                            <div class="platform-user__name">
                                {{userInfo.name}}<span v-if="isEmpowerUser">({{empowerUserName}})</span>
                            </div>
                            <i class="el-icon-caret-bottom"></i>
                        </div>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="!isEmpowerUser">
              <span
                  v-if="isShowByPermission('/wyms/auth/queryAuthLoginListZ')"
                  @click="jumpToPage('/main/empower')"
                  style="display:block;"
              >授权登录</span>
                        </el-dropdown-item>
                        <el-dropdown-item v-else>
              <span
                  @click="returnToSelfFunc()"
                  style="display:block;"
              >切回自己</span>
                        </el-dropdown-item>
                        <el-dropdown-item>
              <span
                  @click="logout"
                  style="display:block;"
              >退出登录</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="lower-container">
            <div class="side-bar" v-show="!!moduleList[navbar]">
                <el-menu
                    unique-opened :style="{height: `${windowHeight - 70}px `}"
                    :default-openeds="openedArray"
                >
                    <template v-for="(moduleItem, moduleIndex) in moduleList[navbar]">
                        <template v-if="!moduleItem.children || moduleItem.children.length === 0"
                        >
                            <el-menu-item
                                :index="`${moduleItem.index}`"
                                :key="`module-${moduleIndex}`"
                                v-if="isShowSideitem(moduleItem)"
                            >
                                <div class="side-item">
                                    <div v-if="moduleItem.isOpen" class="side-item__inner" @click="handleOpenRoute(moduleItem.routePath)">
                                        <div class="side-item__name">
                                            <i :class="['icon', `icon--${moduleItem.moduleIcon}`]"></i>
                                            {{moduleItem.name}}
                                        </div>
                                        <i class="el-icon-arrow-right"></i>
                                    </div>
                                    <router-link v-else :to="moduleItem.routePath">
                                        <div class="side-item__inner">
                                            <div class="side-item__name">
                                                <i :class="['icon', `icon--${moduleItem.moduleIcon}`]"></i>
                                                {{moduleItem.name}}
                                            </div>
                                            <i class="el-icon-arrow-right"></i>
                                        </div>
                                    </router-link>
                                </div>

                            </el-menu-item>
                        </template>
                        <template v-else>
                            <el-submenu
                                :index="`${moduleItem.index}`"
                                :key="`module-${moduleIndex}`"
                                v-if="isShowSideitem(moduleItem)"
                            >
                                <template slot="title">
                                    <div
                                        class="side-item__inner"
                                        style="padding-left: 30px;"
                                    >
                                        <div
                                            class="side-item__name"
                                            style="padding-left: 0px">
                                            <!-- style="padding-left: 3px"> -->
                                            <i :class="['icon', `icon--${moduleItem.moduleIcon}`]"></i>
                                            {{moduleItem.name}}
                                        </div>
                                    </div>
                                </template>
                                <template>
                                    <div
                                        style="padding-left: 20px;"
                                        v-for="(subModuleItem, subModuleIndex) in moduleItem.children"
                                    >
                                        <template v-if="isShowSideitem(subModuleItem)">
                                            <div v-if="subModuleItem.isOpen" class="side-item__inner" @click="handleOpenRoute(subModuleItem.routePath)">
                                                <span class="side-item__name">{{subModuleItem.name}}</span>
                                            </div>
                                            <router-link
                                                v-else
                                                :to="subModuleItem.routePath"
                                            >
                                                <div class="side-item__inner">
                                                    <span class="side-item__name">{{subModuleItem.name}}</span>
                                                </div>
                                            </router-link>
                                        </template>
                                    </div>
                                </template>
                            </el-submenu>
                        </template>

                    </template>

                </el-menu>
            </div>
            <div
                class="lower-container__main"
                :style="{height: `${windowHeight - 70}px`, width: `${moduleList[navbar] ? windowWidth - 200 : windowWidth}px`}"
            >
                <div class="lower-container__inner">
                    <keep-alive>
                        <router-view v-if="$route.meta.isCached"></router-view>
                    </keep-alive>
                    <router-view v-if="!$route.meta.isCached"></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moduleList from "@/router/moduleList";
    import {isShowByPermission} from "@/utils/utils";
    import {updateReleaseRunAs} from "@/api/empower";
    import windowResize from "@/mixins/windowResize.js";
    import baseMixin from "@/mixins/baseMixin.js";

    import {mapGetters} from "vuex";

    export default {
        name: "Main",
        mixins: [windowResize, baseMixin],
        data() {
            return {
                navbarKeyList: [],
                navbar: "",
                navbarList: [
                    {
                        moduleKey: "customService",
                        name: "客服体系",
                        path: "/main/customService",
                        permissionPath: '/wyms/custom'
                    },
                    {
                        moduleKey: "dataAnalysis",
                        name: "数据分析",
                        path: "/main/dataAnalysis",
                        permissionPath: '/wyms/data'
                    },
                    {
                        moduleKey: "developmentSystem",
                        name: "研发体系",
                        path: "/main/developmentSystem",
                        permissionPath: '/wyms/dev'
                    },
                    {
                        moduleKey: "systemMaintain",
                        name: "系统维护",
                        path: "/main/systemMaintain",
                        permissionPath: '/wyms/system'
                    },
                     {
                        moduleKey: "systemoperation",
                        name: "系统运营",
                        path: "/main/systemoperation",
                        permissionPath: '/wyms/SystemOperation'
                    },
                    {
                        moduleKey: "iPayment",
                        name: "资金监管（银行）",
                        path: "/main/iPayment",
                        permissionPath: '/fundApply/getFundApplyListByFinanceBatch'
                    },
                    {
                        moduleKey: "iPayment",
                        name: "资金监管（教育局）",
                        path: "/main/newiPayment",
                        permissionPath: '/fundApply/getFundApplyListByEduBatch'
                    },
                ],
                modulePermissionList: {},
                moduleList,
                openedArray: [],
            };
        },
        computed: {
            ...mapGetters([
                "userInfo",
                "permission",
                "schoolInfo",
                "isTeacher",
                "empowerUserName",
                "isEmpowerUser",
            ]),
        },
        watch: {
            $route: function (newValue) {
                if (newValue.meta.permissionPath) {
                    if (!isShowByPermission(newValue.meta.permissionPath)) {
                        this.$router.replace("/404");
                    }
                }
                this.moduleList = moduleList;
                this.navbarKeyList = Object.keys(moduleList);
                this.navbar = this.$route.path.match(/^\/.*?\/(.*?)($|\/)/)[1];
                const hashArray = newValue.path.split("/");
                const openedArraySegment = [];
                for (let i = 0; i < 4; i++) {
                    openedArraySegment.push(hashArray[i]);
                }
                console.log([openedArraySegment.join("/")]);
                this.openedArray = [openedArraySegment.join("/")];
            },
        },

        created() {
            // if(this.isShowByPermission('/fundApply/getFundApplyListByFinanceBatch')){
            //     this.$router.replace("/main/iPayment/homePage");
            // }else{
            //      if(this.isShowByPermission('/fundApply/getFundApplyListByEduBatch')){
            //     this.$router.replace("/main/newiPayment/homePage");
            // }
            // }

            const modulePermissionList = {};
            this.modulePermissionList = Object.keys(moduleList).forEach((key) => {
                modulePermissionList[key] = moduleList[key].map(
                    (item) => item.permissionPath
                );
            });
            this.modulePermissionList = modulePermissionList;
            this.navbarKeyList = Object.keys(moduleList);
            this.navbar = this.$route.path.match(/^\/.*?\/(.*?)($|\/)/)[1];
        },
        methods: {
            isShowByPermission,
            isShowSideitem: function (moduleItem) {
                return (
                    !moduleItem.permissionPath ||
                    isShowByPermission(moduleItem.permissionPath)
                );
            },
            logout() {
                this.$store.dispatch("LogOut").then(() => {
                    // location.reload();// 为了重新实例化vue-router对象 避免bug
                    this.$router.push("/login");
                });
            },
            returnToSelfFunc() {
                updateReleaseRunAs().then(() => {
                    setTimeout(() => {
                        window.location.reload();
                    }, 200);
                    this.$router.push("/main/customService/schoolManage/schoolList");
                });
            },
            handleOpenRoute(url) {
                window.open(url)
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import "../styles/mixin";

    ul {
        list-style-type: none;
    }

    .icon {
        display: inline-block;
        vertical-align: middle;
        position: relative;
        top: -3px;
        margin-right: 8px;
        @include wh(18px, 18px);
        background: no-repeat center center / cover;

        &.icon--home {
            background-image: url(../assets/images/homepage-icon.png);
        }

        &.icon--yyjr {
            background-image: url(../assets/images/icons/yyjr.png);
        }

        &.icon--xxgl {
            background-image: url(../assets/images/icons/xxgl.png);
        }

        &.icon--qxtx {
            background-image: url(../assets/images/icons/qxtx.png);
        }

        &.icon--bpmb {
            background-image: url(../assets/images/icons/bpmb.png);
        }

        &.icon--cygj {
            background-image: url(../assets/images/icons/cygj.png);
        }

        &.icon--czczjk {
            background-image: url(../assets/images/icons/czczjk.png);
        }
        &.icon--mgcgl {
            background-image: url(../assets/images/icons/mgcgl.png);
        }
        &.icon--gzl {
            background-image: url(../assets/images/icons/gzl.png);
        }

        &.icon--hyd {
            background-image: url(../assets/images/icons/hyd.png);
        }

        &.icon--jxsgl {
            background-image: url(../assets/images/icons/jxsgl.png);
        }

        &.icon--qxtx {
            background-image: url(../assets/images/icons/qxtx.png);
        }

        &.icon--sjtj {
            background-image: url(../assets/images/icons/sjtj.png);
        }

        &.icon--ssyy {
            background-image: url(../assets/images/icons/ssyy.png);
        }

        &.icon--yjgl {
            background-image: url(../assets/images/icons/yjgl.png);
        }

        &.icon--tjtx {
            background-image: url(../assets/images/icons/tjtx.png);
        }

        &.icon--wlxt {
            background-image: url(../assets/images/icons/wlxt.png);
        }

        &.icon--xtsj {
            background-image: url(../assets/images/icons/xtsj.png);
        }

        &.icon--xx {
            background-image: url(../assets/images/icons/xx.png);
        }

        &.icon--xz {
            background-image: url(../assets/images/icons/xz.png);
        }
        &.icon--zybdtj {
            background-image: url(../assets/images/icons/zybdtj.png);
        }
        &.icon--merchantMan {
            background-image: url('https://cdnfile-10043692.cossh.myqcloud.com/admin/images/wy_manage/merchantMan.png');
        }
        &.icon--fundStatement {
            background-image: url('https://cdnfile-10043692.cossh.myqcloud.com/admin/images/wy_manage/fundStatement.png');
        }
        &.icon--orderMan {
            background-image: url('https://cdnfile-10043692.cossh.myqcloud.com/admin/images/wy_manage/orderMan.png');
        }
        &.icon--noticeRecord {
            background-image: url('https://cdnfile-10043692.cossh.myqcloud.com/admin/images/wy_manage/noticeRecord.png');
        }
    }
</style>
<style lang="scss">
    @import "../styles/mixin";

    .main .logo {
        @include middleIB;
        @include wh(50px, 50px);
        position: relative;
        top: -2px;
        margin-right: 20px;
        background: no-repeat center center / contain;
        background-image: url(../assets/images/logo.png);
    }

    .router-link-active {
        color: #20a0ff !important;
    }

    .platform-header {
        height: 70px;
        background: linear-gradient(to bottom, #54b4eb, #31a5e8);
        border-bottom: 3px solid #2096db;
    }

    .platform-logo-container {
        float: left;
        color: #fff;
        font-size: 32px;
        height: 70px;
        line-height: 70px;
        margin-left: 72px;
    }

    .platform-user {
        float: right;
        margin-right: 22px;
        cursor: pointer;
    }

    .platform-user__avatar-inner {
        height: 70px !important;
        color: #fff !important;

        & > * {
            font-size: 20px !important;
            height: 70px !important;
            line-height: 72px !important;
            @include middleIB;
        }

        img {
            width: 54px !important;
            height: 54px !important;
            box-sizing: border-box !important;
            border: 2px solid #fff !important;
            border-radius: 50% !important;
        }

        .platform-user__name {
            font-size: 16px !important;
            margin: 0 14px !important;
        }
    }

    .side-bar {
        float: left;
        margin-left: -20px;
        width: 220px;
        text-align: left;
        overflow-x: hidden;
        overflow-y: auto;

        .side-item {
            height: 56px;
            line-height: 56px;
        }

        .side-item__inner {
            border-left: 4px solid transparent;
            padding-left: 10px;
            height: 56px;
            line-height: 56px;
        }

        .side-item__name {
            width: 120px;
            @include middleIB;
            font-size: 15px;
        }

        i {
            font-size: 14px;
        }
    }

    .lower-container__main {
        float: left;
        box-sizing: border-box;
        padding: 10px;
        background-color: #f1f1f1;

        .lower-container__inner {
            overflow-y: auto;
            @include scrollBar;
            width: 100%;
            height: 100%;
            background-color: #fff;
        }
    }

    #main {
        .nav-item-container {
            border-radius: 2px;
            list-style: none;
            position: relative;
            margin: 0;
            padding-left: 0;
        }

        .nav-item {
            color: #fff;
            list-style-type: none;
            float: left;
            height: 60px;
            line-height: 60px;
            margin: 0;
            cursor: pointer;
            position: relative;
            box-sizing: border-box;
            border-bottom: 5px solid transparent;
            transition: border-color 0.3s, background-color 0.3s, color 0.3s;
            white-space: nowrap;
            font-size: 16px;

            a {
                padding: 0 20px;
                display: block;

                &.router-link-active {
                    color: #fff !important;
                }

                &:hover {
                    color: #fff !important;
                }
            }
        }

        .navbar-munu {
            min-width: 600px;
            float: left;
            padding-top: 0px;
            padding-left: 20px;
            font-size: 18px !important;
            margin-top: 5px;
        }

        .navbar-munu li {
            font-size: 16px;
        }

        .router-link-active {
            .side-item__inner {
                background-color: #ecf8ff;
                border-left: 4px solid #20a0ff;
            }

            .el-icon-arrow-right {
                color: #20a0ff !important;
            }
        }

        .el-menu-item {
            padding-right: 0;

            &:hover {
                a {
                    color: #20a0ff !important;
                }
            }
        }

        .el-submenu__title {
            padding: 0 !important;

            &:hover {
                color: #20a0ff !important;
            }
        }

        .el-submenu__icon-arrow {
            margin-right: 5px;
            width: 24px;
            text-align: center;
            font-size: 18px;
            vertical-align: middle;
            right: 30px;
        }
    }

    .el-breadcrumb {
        height: 50px !important;
        line-height: 50px !important;
        font-size: 16px !important;
    }

    .is-opened {
        border-left: 0 !important;

        .side-item__inner {
            background-color: #ecf8ff !important;
            border-left: 4px solid #20a0ff !important;
            padding-left: 70px;

            &:hover {
                color: #20a0ff !important;
            }
        }

        .el-submenu__title {
            border-left: 4px solid #20a0ff !important;
            padding: 0 !important;
            margin-left: -4px !important;
            padding-left: 20px !important;
        }
    }

    .el-breadcrumb__inner {
        font-weight: normal !important;
    }

    .el-icon-arrow-down:before {
        content: "\E6E0" !important;
    }

    .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
        transform: rotateZ(90deg) !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/Main.vue